<template>
  <div class="wrap">
    <div v-if="tickets.length < 1">
      <h1 style="text-align: center" >
        {{translate('no_data')}}
      </h1>
    </div>

    <div v-else class="response_table">
      <table>
        <thead>
        <tr>
          <th scope="col" @click="request_sort('id')" class="pointer w1" :class="{'selected' : filter_type === 'id'}">
            ID
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'id'}"></i>
          </th>
          <th scope="col" @click="request_sort('title')" class="pointer w5" :class="{'selected' : filter_type === 'title'}">
            {{ translate('support.topic') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'title'}"></i>
          </th>
          <th scope="col" @click="request_sort('device_fid')" class="pointer w5" :class="{'selected' : filter_type === 'device_fid'}">
            {{ translate('support.device') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'device_fid'}"></i>
          </th>
          <th scope="col" @click="request_sort('client')" class="pointer w4" :class="{'selected' : filter_type === 'client'}">
            {{ translate('support.client') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'client'}"></i>
          </th>
          <th scope="col" @click="request_sort('user_name')" class="pointer w4" :class="{'selected' : filter_type === 'user_name'}">
            {{ translate('support.creator_user') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'user_name'}"></i>
          </th>
          <th scope="col" @click="request_sort('status')" class="pointer w3" :class="{'selected' : filter_type === 'status'}">
            {{ translate('support.status') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'status'}"></i>
          </th>
          <th scope="col" @click="request_sort('ts_update')" class="pointer w3" :class="{'selected' : filter_type === 'ts_update'}">
            {{ translate('support.update') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'ts_update'}"></i>
          </th>
          <th scope="col" @click="request_sort('user_updated')" class="pointer w5" :class="{'selected' : filter_type === 'user_updated'}">
            {{ translate('support.user_update') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'user_updated'}"></i>
          </th>
          <th scope="col" class="pointer w10">
            {{ translate('support.descr') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'descr'}"></i>
          </th>
          <th scope="col" @click="request_sort('executor_user_name')" class="pointer w5" :class="{'selected' : filter_type === 'executor_user_name'}">
            {{ translate('support.executor_user') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'executor_user_name'}"></i>
          </th>
        </tr>
        </thead>
        <tbody>
          <tr v-if="loading" class="loading">
            <td> <scale-loader /> </td>
          </tr>

          <router-link
              v-for="(ticket,key) in tickets"
              :key="key"
              :to="'/ticket/' + ticket.id"
              class="link"
          >

            <tr class="ticket">
              <td data-label="ID" class="w1" >
                {{ ticket.id }}
              </td>
              <td :data-label="translate('support.topic')" class="w5">
                {{ ticket.title }}
              </td>
              <td :data-label="translate('support.device')" @click.stop="" class="w5">
                <router-link :to="{path: '/device/' + ticket.device_fid}">
                  {{ ticket.device_fid }}
                </router-link>
                <p>
                  {{ ticket.device_name }}
                </p>
              </td>
              <td :data-label="translate('support.client')" class="w4">
                {{ ticket.client_name }}
              </td>
              <td :data-label="translate('support.creator_user')" class="w4">
                {{ ticket.user_name }}
              </td>
              <td :data-label="translate('support.status')" class="w3">
                <span class="badge" :class="ticket_status[ticket.status].color">
                  {{ ticket_status[ticket.status].title }}
                </span>
              </td>
              <td :data-label="translate('support.update')" class="w3" v-html="get_date_update(ticket.ts_update)"></td>
              <td :data-label="translate('support.user_update')" class="w5">
                {{ ticket.user_updated }}
              </td>
              <td :data-label="translate('support.descr')" class="w10">
                {{ ticket.description.substring(0, 50) }}
              </td>
              <td :data-label="translate('support.executor_user')" class="w5">
                {{ ticket.executor_user_name }}
              </td>
            </tr>

          </router-link>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListTickets',
  props: ['filter_asc', 'filter_type', 'tickets', 'show_new_ticket', 'device_id'],
  data() {
    return {
      check_search: false,
      loading: true,
    }
  },
  created() {
    if (this.tickets && this.tickets.length > 0) {
      this.loading = false
    }
  },
  computed: {
    ticket_status() {
      return this.$store.getters.getTicketStatus
    },
    permissions() {
      return this.$store.getters.getPermissions
    },
  },
  watch: {
    tickets() {
      if (this.tickets && this.tickets.length > 0) {
        this.loading = false
      }
    }
  },
  methods: {
    request_sort(type) {
      this.$emit('change_filter', type)
    },

    get_date_update(ts) {
      let date = Math.floor(new Date(ts * 1000) / 1000)
      let this_date = Math.floor(new Date / 1000)

      var duration = Math.round(this_date - date);
      let minutes = 0
      let hours = Math.round(duration / (60 * 60));
      let days = 0

      if (hours > 48) {
        return this.get_date_any_lines(date, null, 2)
      } else if (hours > 24 && hours <= 48) {
        hours = Math.round(((duration / 60) % 60) % 24);
        days = Math.round(((duration / 60) / 60) / 24);
        return days + " " + this.translate('simcard_devices.d_ago') + " " + hours + " " + this.translate('simcard_devices.h_ago')
      } else if (hours >= 1 && hours <= 24) {
        return hours + " " + this.translate('simcard_devices.h_ago')
      } else if (hours < 1) {
        minutes = Math.round(duration / 60);
        return minutes + " " + this.translate('simcard_devices.min_ago')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  border: none;
  background-color: transparent;
  height: 70px;
}

.wrap {
  display: block;
  height: 100%;
}

.ticket {
  cursor: pointer;
  padding: 2px;
  font-size: 12px;
  a,p{
    font-size: 12px;
    margin-bottom: 0;
  }

  &:hover {
    background-color: #eee;
  }

  td{
    vertical-align: middle;
  }
}

.response_table {
  height: 100%;
  padding-right: 0;
  padding-left: 0;
  padding-top: 0;

  table {
    height: 100%;

    thead {
      height: 50px;
      flex: 0;
      display: inline-block;
    }

    td, th {
      font-size: 12px;
      &.w1 {
        width: 2.5%;
      }

      &.w3 {
        width: 7.5%;
      }

      &.w4 {
        width: 10%;
      }
      &.w5 {
        width: 15%;
      }
      &.w10 {
        width: 25%;
      }
    }

    th {
      i {
        opacity: 0;
        width: 0;
        display: inline-block;
      }

      &.selected {
        color: #000;

        i {
          opacity: 1;
          width: auto;
        }
      }
    }
  }
}

.pointer {
  cursor: pointer;
}

.mdi-arrow-down {
  transform: rotate(0);
  transition: 0.2s;

  &.reverse::before {
    transform: rotate(180deg);
  }
}

@media (max-width: 1366px) {
  .support_header {
    height: 85px;
    padding: 10px 0;
  }
  .response_table {
    padding: 1vh 0 0;

    table {
      font-size: 13px;

      td, th {
        &.w1 {
          width: 30px;
        }

        &.w3 {
          width: 80px;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .response_table {
    table {
      font-size: 12px;

      td, th {
        &.w4 {
          width: 90px;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .response_table {
    padding: 0 10px;
  }
  .support_header {
    .btn-fill {
      b {
        display: none;
      }
    }

    .form-group {
      &--wrap {
        width: 100%;
        margin-right: 10px;
      }
    }
  }
}
</style>
